import { render, staticRenderFns } from "./LegalTypologyForm.vue?vue&type=template&id=5fba30a0&scoped=true&"
import script from "./LegalTypologyForm.vue?vue&type=script&lang=js&"
export * from "./LegalTypologyForm.vue?vue&type=script&lang=js&"
import style0 from "./LegalTypologyForm.vue?vue&type=style&index=0&id=5fba30a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fba30a0",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VForm,VSpacer,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fba30a0')) {
      api.createRecord('5fba30a0', component.options)
    } else {
      api.reload('5fba30a0', component.options)
    }
    module.hot.accept("./LegalTypologyForm.vue?vue&type=template&id=5fba30a0&scoped=true&", function () {
      api.rerender('5fba30a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/company/LegalTypologyForm.vue"
export default component.exports